import {useEffect} from "react";
import {useNavigate} from "react-router";
import useAuth from "./useAuth";

/**
 * Redirects to login if not authenticated.
 * @param redirectPath The path to redirect to if unauthenticated. Defaults to "/auth".
 */
export function useAuthRedirect(redirectPath: string = "/auth") {
    const {accessToken} = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!accessToken) {
            navigate(redirectPath, {replace: true});
        }
    }, [accessToken, navigate, redirectPath]);

}
